import React, { useEffect, useState } from 'react'
import reactCSS from 'reactcss'
import DateRangePicker from 'react-daterange-picker'
import { 
  Input,
  InputGroup,
  InputGroupAddon 
} from 'reactstrap'
import 'react-daterange-picker/dist/css/react-calendar.css'
import moment from 'moment'

const DateOnly = ({ name = null, value, onChange }) => {

  const [date, setDate] = useState(null)
  const [time, setTime] = useState('00:00:00')
  const [selectedDate, setSelectedDate] = useState('')
  const [displayDatePicker, setDisplayDatePicker] = useState(false)

  useEffect(() => {
    if (value) {
      const dt = value.split('T')
      setSelectedDate(moment(dt[0]).format('DD/MM/YYYY'))
    } else {
      setSelectedDate('')
    }
  }, [value])

  const onSelect = currentDate => {
    let dateTime = currentDate.format('YYYY-MM-DD')+'T'+time
    onChange(dateTime, name)
    setSelectedDate(currentDate.format('DD/MM/YYYY'))
    setDate(currentDate)
    setDisplayDatePicker(false)
  }

  const handleClick = () => {
    setDisplayDatePicker(!displayDatePicker)
  }

  const handleClose = () => {
    setDisplayDatePicker(false)
  }

  const styles = reactCSS({
    'default': {
      swatch: {
        padding: '5px 10px',
        background: '#fff',
        borderRadius: '3px',
        border: '1px solid #cccccc',
        cursor: 'pointer',
      },
      popover: {
        position: 'absolute',
        background: '#fff',
        border: '1px solid #cccccc',
        borderRadius: '3px',
        marginTop: '45px',
        zIndex: '2',
      },
      cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
      },
      date:{
        background: 'transparent',
      },
    },
  });
  
  return (
    <InputGroup>
      <Input 
        style={ styles.date }
        value={selectedDate || ''}
        name={name}
        readOnly
        onClick={handleClick} />

      { displayDatePicker ? <div style={ styles.popover }>
        <div style={ styles.cover } onClick={ handleClose }/>
        <DateRangePicker
          onSelect={onSelect}
          value={date}
          selectionType="single"
        />
      </div> : null }

      <InputGroupAddon addonType="append">
        <div style={styles.swatch} onClick={handleClick}>
          <i className="fa fa-calendar"></i>
        </div>
      </InputGroupAddon>
    </InputGroup>
  )
}

export default DateOnly